export function IconGrid() {
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="white">
      <rect x={1} y={1} width={6} height={6} rx={1}/>
      <rect x={9} y={1} width={6} height={6} rx={1}/>
      <rect x={1} y={9} width={6} height={6} rx={1}/>
      <rect x={9} y={9} width={6} height={6} rx={1}/>
    </svg>
  );
}

export function IconSearch() {
  return (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
      <circle cx={11} cy={11} r={8}/>
      <line x1={21} y1={21} x2={16.65} y2={16.65}/>
    </svg>
  );
}

export function IconTrend() {
  return (
    <svg width={18} height={12} viewBox="0 0 18 12" fill="none" stroke="#2d8a8a" strokeWidth={2}>
      <polyline points="1,10 6,5 10,8 17,1"/>
      <polyline points="13,1 17,1 17,5"/>
    </svg>
  );
}

export function IconCal() {
  return (
    <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
      <rect x={3} y={4} width={18} height={18} rx={2}/>
      <line x1={16} y1={2} x2={16} y2={6}/>
      <line x1={8}  y1={2} x2={8}  y2={6}/>
      <line x1={3}  y1={10} x2={21} y2={10}/>
    </svg>
  );
}

export function IconHome() {
  return (
    <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  );
}

export function IconMenu() {
  return (
    <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
      <line x1={3} y1={6}  x2={21} y2={6}/>
      <line x1={3} y1={12} x2={21} y2={12}/>
      <line x1={3} y1={18} x2={21} y2={18}/>
    </svg>
  );
}

export function IconClose() {
  return (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
      <line x1={18} y1={6} x2={6} y2={18}/>
      <line x1={6} y1={6} x2={18} y2={18}/>
    </svg>
  );
}

export function IconChevron({ open }) {
  return (
    <svg
      width={12} height={12} viewBox="0 0 12 12"
      fill="none" stroke="white" strokeWidth={2}
      style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition:"transform 0.2s" }}
    >
      <polyline points="2,4 6,8 10,4"/>
    </svg>
  );
}

export function IconPlus() {
  return (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
      <line x1={12} y1={5} x2={12} y2={19}/>
      <line x1={5}  y1={12} x2={19} y2={12}/>
    </svg>
  );
}
